import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  isSupported,
  onMessage,
} from "firebase/messaging";
import apiRequest from "src/common/utils/apiRequest";
import coreFunctions from "src/common/utils/coreFunctions";

const firebaseConfig = {
  apiKey: "AIzaSyCO3rxBWZxk-durYN7cRfkXqWq7KOWkaNE",
  authDomain: "physio-medicare.firebaseapp.com",
  projectId: "physio-medicare",
  storageBucket: "physio-medicare.firebasestorage.app",
  messagingSenderId: "506081393061",
  appId: "1:506081393061:web:fff4e0b343611533af104c",
  measurementId: "G-BFCBP5LBB0",
};

const app = initializeApp(firebaseConfig);

let messaging: ReturnType<typeof getMessaging> | null = null;

isSupported().then((supported: any) => {
  if (supported) {
    messaging = getMessaging(app);
  } else {
    console.warn("Firebase messaging not supported in this browser.");
  }
});

const getFCMToken = async (): Promise<string | null> => {
  if (!messaging) return null;

  try {
    const currentToken = await getToken(messaging, {
      vapidKey:
        "BIstHng3dmK7PMtietaD9clkRGQaXa3JLZNb4rjYiVkbJ3-o7KnD-i8s_METubfFfkPEYix_Hkp6aNtlFdleNVA",
    });

    return currentToken || null;
  } catch (error) {
    console.error("FCM Token error:", error);
    return null;
  }
};

const requestPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted")
      throw new Error("Notification permission not granted");

    const token = await getFCMToken();
    if (token) {
      const API_REQUEST = new apiRequest("save-fcm-token", true);
      await API_REQUEST.send({
        device_token: token,
        device: coreFunctions.isMobileDevice() ? "mobile" : "web",
      });
    }
  } catch (error) {
    console.error("🔴 FCM Init error:", error);
  }
};

export default requestPermission;
